<organization-select    
#orgManager
autoSelectFirst = "true"
class           = "mr-3"
>
</organization-select> 

<site-select            
#siteManager
[org]           = "orgManager?.currentValue"
autoSelectFirst = "true"
(change)        = "siteChange($event)"
class           = "mr-3"
>
</site-select>

<custom-select          
#modelManager  
*ngIf           =   "models"
[values]        =   "models"
title_single    =   "custom.models.title"
title_multiple  =   "custom.models.title"
autoSelectFirst =   "true"
(change)        =   "modelChange($event)"
class           =   "mr-3"
>
</custom-select>

<day-select            
#dayManager
*ngIf           =   "model"
(change)        =   "dayChange($event)"
class           =   "mr-3"
>
</day-select>

<br>

<help-alert 
                        action      = "help.page.slot_model.action" 
                        description = "help.page.slot_model.description" 
                        info        = "help.info"></help-alert>

<br>
<br>

<button type="button" class="btn btn-outline-secondary mr-3 mb-3" (click)="goBack()" translate>pages.slotmodel.back</button>
<button type="button" class="btn btn-outline-secondary mr-3 mb-3" (click)="createModel()" translate>pages.slotmodel.create</button>
<button *ngIf="model" type="button" class="btn btn-outline-secondary mr-3 mb-3" (click)="modifyModel()" translate>pages.slotmodel.modify</button>

<br>
<br>

<custom-table           
#slotModelTable
table_id            =   "slotModelTable"
no_title_value      =   "tables.slotautomate.no_title_value"
title_single        =   "tables.slotmodel.table_title"
title_multiple      =   "tables.slotmodel.table_title"
filter_title        =   "tables.slotmodel.filter_title"
search_title        =   "tables.slotmodel.search_title"
reloadable          =   "true"
(refresh)           =   "loadDetails()"
[columns]           =   "slotmodelColumns"
[values]            =   "values"
[parent]            =   "this"
[create]            =   "false"
[update]            =   "false"
[icon_buttons]      =   "icon_buttons"
[header_buttons]    =   "header_buttons"
[filter_columns]    =   "false"
>
</custom-table>
